import { combineReducers } from 'redux';

import * as types from './types';
import notifications from './notificationsSlice';
import { customerApi } from './customersApi';
import { subscriptionsApi } from './subscriptionsApi';
import { deviceApi } from './devicesApi';
import { productsApi } from './productsApi';
import { chargesApi } from './chargesApi';
import { paymentsApi } from './paymentsApi';
import { addressesApi } from './addressesApi';
import { ordersApi } from './ordersApi';
import { returnOrdersApi } from './returnOrdersApi';
import { returnLabelsApi } from './returnLabelsApi';

const rootReducer = combineReducers({
  [customerApi.reducerPath]: customerApi.reducer,
  [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
  [deviceApi.reducerPath]: deviceApi.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  [chargesApi.reducerPath]: chargesApi.reducer,
  [paymentsApi.reducerPath]: paymentsApi.reducer,
  [addressesApi.reducerPath]: addressesApi.reducer,
  [ordersApi.reducerPath]: ordersApi.reducer,
  [returnOrdersApi.reducerPath]: returnOrdersApi.reducer,
  [returnLabelsApi.reducerPath]: returnLabelsApi.reducer,
  notifications,
});

// reset store on logout
const appReducer = (state, action) =>
  rootReducer(action.type === types.LOGOUT ? undefined : state, action);

export default appReducer;
